<div class="qtct">

  <div class="header-component">
    <a class="title-view"><i class="fa fa-building" aria-hidden="true"></i>Quá trình đào tạo</a>
    <a *ngIf="nhansuId!==0 && quyen_them==true" (click)="RowNewDonViClick()" class="btn btn-primary" style="margin-right:5px;cursor:pointer;"><em class="mr-2 fa fa-plus"></em>Thêm mới</a>
    <!--<a (click)="closeModal()" class="btn btn-primary" style="color:#fff;cursor:pointer;"><i class="fa fa-close"></i>Đóng</a>-->
  </div>
  <table class="table tableinput table-bordered table-hover" style="background:#fff;">
    <thead>
      <tr>
        <th width="1%">STT</th>
        <th width="10%">Từ tháng</th>
        <th width="10%">Đến tháng</th>
        <th width="15%">Nơi đào tạo</th>
        <th width="15%">Chuyên ngành</th>
        <th width="15%">Hình thức đào tạo</th>
        <th width="15%">Trình độ</th>
        <th width="10%">#</th>

      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor='let r of QTCT; let i = index'>
        <tr style="background:#e6dcdc;"><td colspan="8">{{r.name}}</td></tr>

        <tr *ngFor='let row of r.values; let i = index' [ngClass]="{'selectBold':row.DinhDang==1}">

          <td>{{i+1}}</td>
          <td>
            <a (click)="boNhiemRowSelect(row)">
              {{row.NgayBatDau | date:'MM/yyyy'}}
            </a>
          </td>
          <td>
            <a (click)="boNhiemRowSelect(row)">
              {{row.NgayKetThuc | date:'MM/yyyy'}}
            </a>
          </td>
          <td>
            <a (click)="boNhiemRowSelect(row)">
              {{row.DiaDiem}}
            </a>
          </td>
          <td>
            <a (click)="boNhiemRowSelect(row)">
              {{row.ChuyenNganh}}
            </a>

          </td>
          <td>
            <a (click)="boNhiemRowSelect(row)">
              {{row.HinhThucDaoTao}}
            </a>

          </td>
          <td>
            <a (click)="boNhiemRowSelect(row)">
              {{row.TrinhDoHocVan}}
            </a>

          </td>
          <td>
            <div style="">
              <a title="Xóa dòng" (click)="deleterow(i,row.Id)" *ngIf="quyen_xoa==true" style="margin-left:5px;cursor:pointer;color:#1e6bb8 !important" class="mb-1  ng2-smart-action ng2-smart-action-custom-custom ng-star-inserted">
                <em class="mr-2 far fa-trash-alt"></em>Xóa
              </a>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<ejs-dialog #Dialog  [visible]='false' [header]='"Thông tin chi tiết quá trình đào tạo"' [animationSettings]='animationSettings'
            [showCloseIcon]='true' [height]='"100%"' [width]='"70%"' (open)="dialogOpen()" (close)="dialogClose()">
  <div>
    <div class="formedit">

      <div class="form-group row" [hidden]="bonhiemSelect.PhanLoai==0 || bonhiemSelect.PhanLoai==4">
        <label class="col-xl-2 col-form-label">Lĩnh vực đào tạo <span class="required-field"> (*)</span></label>
        <div class="col-xl-10">
          <ng-select style="width:100%;" (change)="onLinhVucChange($event)"
                     [openOnEnter]="false"
                     [items]="inputLinhVucs"
                     bindValue="Id"
                     bindLabel="Ten"
                     notFoundText="Không có dữ liệu"
                     placeholder=""
                     [(ngModel)]="bonhiemSelect.LinhVucDaoTaoId">
          </ng-select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-xl-2 col-form-label">Chuyên ngành<span class="required-field"> (*)</span></label>
        <div class="col-xl-4">
          <ng-select style="width:100%;"
                     [openOnEnter]="false"
                     [items]="inputChuyenNganhs"
                     bindValue="Id"
                     bindLabel="Ten"
                     notFoundText="Không có dữ liệu"
                     placeholder=""
                     [(ngModel)]="bonhiemSelect.ChuyenNganhId">
          </ng-select>
        </div>
        <label class="col-xl-2 col-form-label">Nội dung đào tạo</label>
        <div class="col-xl-4">
          <input type="text" class="form-control" placeholder="" [(ngModel)]="bonhiemSelect.NoiDungDaoTao">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-xl-2 col-form-label">Hình thức đào tạo <span class="required-field"> (*)</span></label>
        <div class="col-xl-4">
          <ng-select style="width:100%;"
                     [openOnEnter]="false"
                     [items]="inputHinhThucDaoTaos"
                     bindValue="Id"
                     bindLabel="Ten"
                     notFoundText="Không có dữ liệu"
                     placeholder=""
                     [(ngModel)]="bonhiemSelect.HinhThucDaoTaoId">
          </ng-select>
        </div>
        <label class="col-xl-2 col-form-label">Nơi đào tạo</label>
        <div class="col-xl-4">
          <input type="text" class="form-control" placeholder="" [(ngModel)]="bonhiemSelect.DiaDiem">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-xl-2 col-form-label">Trình độ đào tạo</label>
        <div class="col-xl-4">
          <ng-select style="width:100%;"
                     [openOnEnter]="false"
                     [items]="inputTrinhDos"
                     bindValue="Id"
                     bindLabel="Ten"
                     notFoundText="Không có dữ liệu"
                     placeholder=""
                     [(ngModel)]="bonhiemSelect.BangCapId">
          </ng-select>
        </div>

      </div>
      <div class="form-group row">
        <label class="col-xl-2 col-form-label">Hạng văn bằng</label>
        <div class="col-xl-4">
          <ng-select style="width:100%;"
                     [openOnEnter]="false"
                     [items]="inputLoaiTotNghieps"
                     bindValue="Id"
                     bindLabel="Ten"
                     notFoundText="Không có dữ liệu"
                     placeholder=""
                     [(ngModel)]="bonhiemSelect.LoaiTotNghiepId">
          </ng-select>
        </div>
        <label class="col-xl-2 col-form-label">Quốc gia</label>
        <div class="col-xl-4">
          <ng-select style="width:100%;"
                     [openOnEnter]="false"
                     [items]="inputQuocGias"
                     bindValue="Id"
                     bindLabel="Ten"
                     notFoundText="Không có dữ liệu"
                     placeholder=""
                     [(ngModel)]="bonhiemSelect.QuocGiaId">
          </ng-select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-xl-2 col-form-label">Số quyết định</label>
        <div class="col-xl-4">
          <input type="text" class="form-control" placeholder="" [(ngModel)]="bonhiemSelect.SoQuyetDinh">
        </div>
        <label class="col-xl-2 col-form-label">Ngày quyết định</label>
        <div class="col-xl-4">          
          <ejs-maskedtextbox style="" width="100px" id="date_check" cssClass="ejInputDate" [mask]="formatDate" #ejNgayQD="" [(value)]='bonhiemSelect.NgayQuyetDinh_S'></ejs-maskedtextbox>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-xl-2 col-form-label">Từ ngày</label>
        <div class="col-xl-4" style="display: flex; justify-content: space-between;">
          <ng-select style="width:50%;float:left;"
                     (change)="onKieuTuNgayChange($event)"
                     [openOnEnter]="false"
                     [items]="inputkieungaysinhs"
                     bindValue="Id"
                     bindLabel="Name"
                     notFoundText="Không có dữ liệu"
                     placeholder=""
                     [searchFn]="comboSearchFn"
                     [(ngModel)]="bonhiemSelect.KieuNgayBatDau">

          </ng-select>          
          <ejs-maskedtextbox style="" width="150px" id="date_check" cssClass="ejInputDate" [mask]="formatDatetn" #ejNgayTN="" [(value)]='bonhiemSelect.NgayBatDau_S'></ejs-maskedtextbox>
        </div>
        <label class="col-xl-2 col-form-label">Đến ngày</label>
        <div class="col-xl-4" style="display: flex; justify-content: space-between;">
          <ng-select style="width:50%;float:left;"
                     (change)="onKieuDenNgayChange($event)"
                     [openOnEnter]="false"
                     [items]="inputkieungaysinhs"
                     bindValue="Id"
                     bindLabel="Name"
                     notFoundText="Không có dữ liệu"
                     placeholder=""
                     [searchFn]="comboSearchFn"
                     [(ngModel)]="bonhiemSelect.KieuNgayKetThuc">
          </ng-select>          
          <ejs-maskedtextbox style="" width="150px" id="date_check" cssClass="ejInputDate" [mask]="formatDatedn" #ejNgayDN="" [(value)]='bonhiemSelect.NgayKetThuc_S'></ejs-maskedtextbox>
        </div>
      </div>


      <div class="form-group row">

        <label class="col-xl-2 col-form-label">Mô tả</label>
        <div class="col-xl-10">
          <input type="text" class="form-control" placeholder="" [(ngModel)]="bonhiemSelect.MoTa">
        </div>
      </div>
      <div class="form-group row" style="justify-content: flex-end;padding-right: 15px;">
        <a (click)="savedt()" *ngIf="(nhansuId!==0 && (quyen_sua==true || quyen_them==true))" class="btn btn-primary" style="margin-right:5px;cursor:pointer;"><em class="mr-2 fas fa-save"></em>Lưu lại</a>
        <a (click)="modal.hide()"  class="btn btn-primary" style="color:#fff;cursor:pointer;"><i class="fa fa-close"></i>Đóng</a>
      </div>

    </div>
  </div>
</ejs-dialog>

